import {
  Form,
} from '@sketchpixy/rubix';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/CheckCircle';
import ShowIcon from '@material-ui/icons/Visibility';
import HideIcon from '@material-ui/icons/VisibilityOff';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import CustomField from './Fields/CustomField.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import { isMobileBrowser } from '../../_config/utils';


const validate = values => {
  const errors = {};

  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords does not match';
  }
  if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[_0-9a-zA-Z\W]{8,}$/.test(values.password)) {
    errors.password = 'Password invalid';
  }

  if (!values.password) {
    errors.password = 'required';
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = 'required';
  }

  return errors;
};

const ConditionStatus = ({ conditionText, isValid, isDarkMode}) => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center',
    padding: '6px 10px',
    backgroundColor: isValid 
      ? (isDarkMode ? 'rgba(76, 182, 172, 0.15)' : 'rgba(76, 182, 172, 0.1)') 
      : (isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'),
    borderRadius: '6px',
    marginBottom: '6px',
    transition: 'all 0.3s ease',
    opacity: isValid ? 1 : 0.6,
  }}>
    <CheckIcon style={{ 
      color: isValid ? '#4DB6AC' : (isDarkMode ? 'rgba(255, 255, 255, 0.3)' : '#ccc'),
      marginRight: 10,
      fontSize: 16,
      transition: 'all 0.3s ease',
    }} />
    <span style={{ 
      color: isDarkMode ? 'white' : '#666',
      fontSize: '13px',
      fontWeight: isValid ? '500' : '400',
      margin: 0,
    }}>{conditionText}</span>
  </div>
);
@reduxForm({ form: 'ConfirmPasswordForm', validate })
class ConfirmPasswordForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isMinimum8CharactersValid: false,
      isUpperLowerValid: false,
      isNumberValid: false,
      isPasswordVisible: false,
    };
  }

  onTextChange(textValue) {
    if (textValue && textValue.length >= 8) {
      this.setState({ isMinimum8CharactersValid: true });
    } else {
      this.setState({ isMinimum8CharactersValid: false });
    }

    if (/[A-Z]/.test(textValue)) {
      this.setState({ isUpperLowerValid: true });
    } else {
      this.setState({ isUpperLowerValid: false });
    }

    if (/\d/.test(textValue)) {
      this.setState({ isNumberValid: true });
    } else {
      this.setState({ isNumberValid: false });
    }
  }
  
  onTogglePasswordVisibility() {
    const { isPasswordVisible } = this.state;
    this.setState({ isPasswordVisible: !isPasswordVisible });
  }

  onToggleConfirmPasswordVisibility() {
    const { isConfirmPasswordVisible } = this.state;
    this.setState({ isConfirmPasswordVisible: !isConfirmPasswordVisible });
  }

  render() {
    const { onValidateForm } = this.props;
    const { isMinimum8CharactersValid, isConfirmPasswordVisible, isPasswordVisible, isNumberValid, isUpperLowerValid } = this.state;
    const isMobile = isMobileBrowser();
    const isDarkMode = isMobile;
    const isSubmitDisabled = !(isMinimum8CharactersValid && isUpperLowerValid && isNumberValid);

    return (
      <Form>
        <div style={{ display: 'flex', position: 'relative', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <input type="hidden" name="password" style={{ display: 'none' }} />
          <Entity
            componentClass={Field}
            name="password"
            type={isPasswordVisible ? 'text' : 'password'}
            componentAttribute="placeholder"
            entity="password"
            titleColor={isDarkMode ? 'white' : '#333'}
            title={<Entity entity="password" />}
            component={CustomField}
            containerStyle={{ width: '100%' }}
            titleStyle={{ fontSize: isMobile ? '14px' : '16px' }}
            hideErrorLabel
            formGroupStyle={{ marginBottom:  isMobile ? '5px' : '10px' }}
            onHandleChange={text => this.onTextChange(text)}
            mandatory
          />
          <IconButton 
            style={{ position: 'absolute', right: '5px', bottom: isMobile ? '1px' : '6px' }} 
            onClick={() => this.onTogglePasswordVisibility()}
            tabIndex={-1}
          >
            {!isPasswordVisible ? <ShowIcon style={{ color: '#3f3f3f', fontSize: 20 }} /> : <HideIcon style={{ color: '#3f3f3f', fontSize: 20 }} />}
          </IconButton>
        </div>
        <div style={{ display: 'flex', position: 'relative', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <Entity
            componentClass={Field}
            name="confirmPassword"
            type={isConfirmPasswordVisible ? 'text' : 'password'}
            componentAttribute="placeholder"
            entity="confirmPassword"
            titleStyle={{ fontSize: isMobile ? '14px' : '16px' }}
            titleColor={isDarkMode ? 'white' : '#333'}
            containerStyle={{ width: '100%' }}
            title={<Entity entity="confirmPassword" />}
            component={CustomField}
            mandatory
            hideErrorLabel
          />
          <IconButton 
            style={{ position: 'absolute', right: '5px', bottom: '11px' }} 
            onClick={() => this.onToggleConfirmPasswordVisibility()}
            tabIndex={-1}
          >
          {!isConfirmPasswordVisible ? <ShowIcon style={{ color: '#3f3f3f', fontSize: 20 }} /> : <HideIcon style={{ color: '#3f3f3f', fontSize: 20 }} />}
          </IconButton>
        </div>
        
        <div style={{ marginBottom: '24px' }}>
          <div style={{ 
            color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : '#666',
            fontSize: '13px',
            fontWeight: '600',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            <Entity entity="passwordRequirements" />
          </div>
          <ConditionStatus
            isValid={isMinimum8CharactersValid}
            isDarkMode={isDarkMode}
            conditionText={<Entity entity="characterPasswordWarning" />}
          />
          <ConditionStatus
            isValid={isUpperLowerValid}
            isDarkMode={isDarkMode}
            conditionText={<Entity entity="upperLowerPasswordWarning" />}
          />
          <ConditionStatus
            isValid={isNumberValid}
            isDarkMode={isDarkMode}
            conditionText={<Entity entity="numberPasswordWarning" />}
          />
        </div>
        
        <MDButton
          disabled={isSubmitDisabled}
          title={<Entity entity="save" />}
          titleStyle={{ fontWeight: 'bold', fontSize: '15px' }}
          backgroundColor="#4DB6AC"
          style={{ height: '45px' }}
          containerStyle={{ 
            margin: 0,
            width: '100%',
            height: '48px',
            opacity: isSubmitDisabled ? 0.5 : 1,
          }}
          onClick={() => onValidateForm()}
        />
      </Form>
    );
  }
} 

export default ConfirmPasswordForm;
